export const FINTRAC_REPORT_STATUSES = [
  "PENDING_REVIEW",
  "REPORTED",
  "NOT_REPORTABLE",
  "ERROR",
] as const;

export type FintracReportStatus = (typeof FINTRAC_REPORT_STATUSES)[number];

export const FINTRAC_PAGE_LIMITS = [20, 50, 100] as const;

export type FintracPageLimit = (typeof FINTRAC_PAGE_LIMITS)[number];

export interface FintracPagination {
  page: number;
  limit: number;
  totalRecords: number;
  totalPages: number;
}

export interface FintracListParams {
  page?: number;
  limit?: number;
  status?: FintracReportStatus;
}

export interface FintracJobRun {
  id: number;
  reportDate: string;
  windowStart: string;
  windowEnd: string;
  usdCadFxRate: string;
  qualifyingUserCount: number;
  qualifyingTransactionCount: number;
  status: string;
  startedAt: string | null;
  completedAt: string | null;
  errorMessage: string | null;
  createdAt: string;
}

export interface FintracReport {
  id: number;
  reportDate: string;
  windowStart: string;
  windowEnd: string;
  userId: number;
  merchantId: string;
  accountCategory: string;
  accountType: string;
  merchantName: string;
  dba: string;
  authorisedPersonName: string;
  emailId: string;
  jobRunId: number;
  transactionCount: number;
  totalUsdAmount: string;
  usdCadFxRate: string;
  totalCadAmount: string;
  thresholdCad: string;
  status: FintracReportStatus;
  reportedAt: string | null;
  fintracReference: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface FintracReportTransaction {
  id: number;
  reportId: number;
  transactionCreatedAt: string;
  transactionId: number;
  orderId: string;
  merchantOrderId: string;
  userId: number;
  merchantId: string | null;
  accountCategory: string | null;
  accountType: string;
  merchantName: string | null;
  dba: string;
  authorisedPersonName: string;
  emailId: string;
  fromAddress: string;
  toAddress: string;
  transactionHash: string;
  cryptoSymbol: string;
  cryptoId: number;
  amountUsd: string;
  amountCad: string;
  usdCadFxRate: string;
  transactionSource: string;
  createdAt: string;
}

export interface FintracJobRunsResponse {
  msg: string;
  data: {
    jobRuns: FintracJobRun[];
    pagination: FintracPagination;
  };
}

export interface FintracReportsResponse {
  msg: string;
  data: {
    jobRunId: number;
    statuses: FintracReportStatus[];
    reports: FintracReport[];
    pagination: FintracPagination;
  };
}

export interface FintracTransactionsResponse {
  msg: string;
  data: {
    reportId: number;
    transactions: FintracReportTransaction[];
    pagination: FintracPagination;
  };
}

export interface FintracWalletParty {
  id: string;
  externalUserId: string;
  type: string;
  firstName: string;
  lastName: string;
  fullName: string;
  dateOfBirth: string;
  placeOfBirth: string;
  residenceCountry: string;
  addressCountry: string;
  addressTown: string;
  addressPostCode: string;
  addressStreet: string;
  addressBuildingNumber: string;
  relationship: string;
  declaredByUserId: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateFintracReportStatusRequest {
  status: FintracReportStatus;
  fintracReference?: string;
}

export interface UpdateFintracReportStatusResponse {
  msg: string;
  data: {
    id: number;
    status: FintracReportStatus;
    fintracReference?: string | null;
  };
}
